export const handleTrackedEvent = (event, handlers) => {
  const { data, origin } = event;

  if (data?.command !== "tracked_event") return;

  const allowedOrigin = window.location.origin;
  if (
    origin !== undefined &&
    allowedOrigin !== undefined &&
    origin !== allowedOrigin
  ) {
    return;
  }

  const eventName = data?.data?.event;

  if (eventName && typeof handlers[eventName] === "function") {
    handlers[eventName](data.data.parameters);
  }
};
